import type { CSSProperties } from "react";

export const dangerButtonStyle: CSSProperties = {
  borderRadius: 10,
  border: "1px solid var(--color-danger)",
  padding: "12px 20px",
  cursor: "pointer",
  fontSize: 15,
  fontFamily: "inherit",
  fontWeight: 700,
  background: "var(--color-danger)",
  color: "var(--color-on-accent)",
};

export const dialogTitleStyle: CSSProperties = {
  margin: 0,
  paddingBottom: 16,
  fontSize: 20,
  fontWeight: 700,
  borderBottom: "1px solid var(--dialog-border-color)",
};
